module.exports = __webpack_public_path__ + "fonts/Adelle_SemiBoldItalic.77d7a28d.woff";